// Form-local fields.
//
// A register form now holds more than the row it saves. When a member is picked
// the whole record comes back with them, and the form keeps it so it can fill
// itself in and so `warn` can ask questions like "has this member already been
// baptised?" — neither of which the register table stores.
//
// Anything the form keeps for itself is named with a leading underscore and
// stripped on the way out, so the payload stays exactly the entity the backend
// declares. Without this a stray key would be silently dropped by Jackson and
// nobody would notice until the data was wrong.

export const FORM_LOCAL_PREFIX = '_';

export const stripFormLocal = <T extends Record<string, unknown>>(form: T): Partial<T> => {
  const out: Record<string, unknown> = {};
  Object.keys(form).forEach((key) => {
    if (!key.startsWith(FORM_LOCAL_PREFIX)) out[key] = form[key];
  });
  return out as Partial<T>;
};
